export default __webpack_public_path__ + "static/media/backgroundsea.e8625ba8.png";